<template>
		<div class="content wrap-page" style="padding-top:20px;height: auto;">
		<Header></Header>
			<div class="info crfff">
        <div class="back" @click="back" style="">
          <img width="50" src="../../static/images/back.png" />
        </div>
        <div class="fs50 w-title mt20 ac">{{$t('RedeemCenter')}}</div>
        <div class="redeem-top ac">
          <div class="crfb7925 por pt-font" style="border-radius: 50px;display: inline-block;margin: 0;">{{$t('ChancesLeft')}}<span style="border-radius: 50px;"> <img src="../../static/images/pt-icon.png">{{info.points}}</span></div>
          <div>
            <div class="current-level">{{$t('currentLevel')}} : {{info.level}}</div>
          </div>
        </div>
<!--        <div class="ac mt20">{{$t('YouCanRedeem')}} [{{redeemList.can_redeem}}] {{$t('moreTimes')}}</div>-->
        <div class="redeem-list mt30">
          <div class="li disflex" @click="getSub(item)" v-for="(item,index) in redeemList.prize">
            <div class="lf" :class="'lf'+index">
              <img :src="item.image" />
            </div>
            <div class="rf">
              <div class="disflex" style="justify-content: space-between;">
                <div class="title">{{item.name}}</div>
                <div class="require">{{item.need_level}}</div>
              </div>
              <div class="prz">{{item.need_points}}</div>
              <div class="disflex">
                <div class="cpon">{{item.number}}</div>
                <button class="btn btn-yellow" style="min-width:50px;margin-left: 10px;">{{$t('Redeem')}}</button>
              </div>
            </div>
          </div>
        </div>
			</div>
      <Dialog ref="redeemDialog" type="alert" title="" width="100" :modalFoot="false" :iscloseMask="true" style="min-height: 300px;">
          <div class="redeem-modal" slot="mdBox" >
                <div class="md-title">{{$t('congratulations')}}</div>
              <div class="close" @click="closeRedeemDialog"><img width="80" src="../../static/images/close.png"></div>
              <div class="image ac">
                <div class="redeem-md">
                  <p>{{$t('redeemTips')}}</p>
                  <div class="tt">{{redeemInfo.name}}</div>
                  <div>
                    <img style="margin: -30px 0;" :src="redeemInfo.image">
                  </div>
                </div>
              </div>
              <button class="btn pt-font fs33" style="border-radius: 100px;" @click="buyRedeem">{{$t('Redeem')}}</button>
          </div>
      </Dialog>
		</div>
</template>
<script>
import Header from '../components/HeaderTwo'
import Dialog from '../components/dialog'
export default {
    components:{
		Header,
    Dialog
    },
    data() {
      return {
       isShow:null,
       info:{},
       redeemInfo:{},
        redeemList:[
          {'title':'iPhone15','prize':'3,000,000pt','coupon':'Coupon Leftx1','level':'Require lvl 6'},
          {'title':'Cash 1 lakh','prize':'100,000pt','coupon':'Coupons Leftx10','level':'Require lvl 8'},
          {'title':'Loyalty 30k','prize':'80,000pt','coupon':'Coupons Leftx30','level':'Require lvl 6'},
          {'title':'Top Up 3,000','prize':'30,000pt','coupon':'Coupons Leftx60','level':'Require lvl 3'},
        ]
      }
    },
	created(){
    this.getUserInfo()
    this.getRedeem()
	},
  methods: {
		back(){
			this.$router.go(-1);
		},
    getRedeem(){
      let that = this
      that.$parent.loadModal(true);
      that.$api.post('/api/index/prize_list',null,r =>{
        that.redeemList = r.data
        that.$parent.loadModal(false);
      })
    },
    getUserInfo(){
      let that = this
      that.$parent.loadModal(true);
      that.$api.post('/api/user/info',null,r =>{
        that.info = r.data
        that.$parent.loadModal(false);
      })
    },
    closeRedeemDialog(){
      this.$refs.redeemDialog.closeMask();
    },
    closeOtpDialog(){
      this.$refs.otpDialog.closeMask();
    },
    getSub(item){
      let that = this;
      that.redeemInfo = item
      console.log(that.redeemInfo)
      that.$refs.redeemDialog.showMaskFun();
    },
    buyRedeem(){
      let that = this;
      let data = {
        "prize_id":that.redeemInfo.id
      }
      that.$parent.loadModal(true);
      that.$api.post('/api/index/redeem_prize',data,r =>{
      	that.$parent.returnCode(r,function(){
      		that.$parent.loadModal(false);
          if (r.code == 1){
            that.$refs.redeemDialog.closeMask();
            that.getUserInfo();
          }
          that.$utils.alertText(r.msg,80, 800);
      	});

      })
    },
    getSendOtp(){
      let that = this
      if(that.isReturn){
        return;
      }
      that.isReturn = true
      that.$api.post('/api/user/send_otp',null,r =>{
        that.$utils.alertText(r.msg,80,3000);
        that.isReturn = false
        this.countDown(61,1)
      })
    },

    // 计时
    countDown (miao,type){
    	if(miao === 1){
    		this.codeText = this.$t('getCode');
    		return;
    	}
    	miao--;
    	if(type === 1){
    		this.codeText = miao + "s";
        this.isReturn = false
    	}
    	setTimeout(() =>{
    		this.countDown(miao,type);
    	},1000)
    }
	}
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/page/RedeemCenter.vue